import uniloc from 'uniloc';
import actionTypes from '../constants/actionTypes';

export const ROUTES = uniloc({
  userIndex: 'GET /users',
  userDetail: 'GET /user/:id',
  userEdit: 'GET /user/:id/edit',
  login: 'GET /login',
  home: 'GET /',
  search: 'GET /search',
  newCollective: 'GET /collective/new',
  newInfluencer: 'GET /influencer/new',
  viewInfluencer: 'GET /influencer/view/:id',
  collectiveViewInfluencer: 'GET /collective/view/:collectiveId/influencer/view/:id',
  influencerViewCollective: 'GET /influencer/view/:influencerId/collective/view/:id',
  viewCollective: 'GET /collective/view/:id',
  editInfluencer: 'GET /influencer/edit/:id',
  editCollective: 'GET /collective/edit/:id',
  importInfluencers: 'GET /import',
  editCollectiveImport: 'GET /import/collective/edit/:id',
});

export function updateLocationState(location) {
  return {
    type: actionTypes.location.LOCATION_CHANGE_COMPLETE,
    route: ROUTES.lookup(location.pathname + location.search),
    search: location.search,
  };
}

export function clearLocationRequest() {
  return {
    type: actionTypes.location.LOCATION_REQUEST_CLEAR,
  };
}

export function clearLocationOptions() {
  return {
    type: actionTypes.location.LOCATION_OPTIONS_CLEAR,
  };
}

export function requestLocationChange(newLocationName, options = {}) {
  const newUrl = ROUTES.generate(newLocationName, options);

  return {
    type: actionTypes.location.LOCATION_REQUEST,
    path: newUrl,
  };
}

function clearLocalSession() {
  localStorage.removeItem('authToken');
  return {
    type: actionTypes.dataFetching.SIGN_OUT_REQUEST_SUCCESS,
  };
}

export function signOut() {
  return dispatch => {
    dispatch(requestLocationChange('login'));
    dispatch(clearLocalSession());
  };
}



/** WEBPACK FOOTER **
 ** ./actions/router.js
 **/